<template>
  <div>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <!-- :width="350"
          :height="240" -->
        <DxPopup
          :width="350"
          :height="inherit"
          :show-title="true"
          title="Update Foto Pegawai"
          :drag-enabled="false"
          :hide-on-outside-click="true"
          v-model:visible="popupVisible"
        >
          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            :options="closeButtonOptionsFoto"
          />

          <template #content>
            <label for="fileUploaderFoto">Foto profil pegawai:</label>
            <DxFileUploader
              ref="fileUploaderFoto"
              accept="image/*"
              upload-mode="useForm"
              name="files"
              multiple="false"
              @value-changed="handleFileUploader($event, 'pegawai_foto')"
            >
            </DxFileUploader>

            <br />
          </template>
        </DxPopup>

        <DxPopup
          v-model:visible="popupFileVisible"
          :drag-enabled="false"
          :hide-on-outside-click="true"
          :show-close-button="false"
          :show-title="true"
          :width="350"
          :height="inherit"
          container=".dx-viewport"
          title="Update File Arsip Pegawai"
        >
          <DxToolbarItem
            widget="dxButton"
            toolbar="top"
            locate-in-menu="always"
            :options="moreInfoButtonOptions"
          />
          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="before"
            :options="emailButtonOptions"
          />
          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            :options="closeButtonOptions"
          />
          <!-- <p>
            <label for="fileDownloader">Download file:</label>
            <span>
              <DxButton icon="download" text="Download" ref="fileDownloader"
            /></span>
          </p> -->
          <!-- <p>
            <label for="fileUploader">Update file baru:</label>
            <span>
              <DxFileUploader
                ref="fileUploader"
                accept="image/*, application/pdf"
                upload-mode="useForm"
                name="files"
                multiple="false"
                @value-changed="handleFileUploader($event, 'ijazah_file')"
              >
              </DxFileUploader>
            </span>
          </p> -->
          <div style="padding-bottom: 30px">
            <div class="uploader-label">Download file:</div>
            <div>
              <DxButton
                icon="download"
                text="Download"
                ref="fileDownloader"
                @click="downloadPdf"
              />
            </div>
          </div>

          <div>
            <div class="uploader-label">Ganti dgn file baru:</div>
            <DxFileUploader
              ref="fileUploaderIjazah"
              accept="image/*, application/pdf"
              upload-mode="useForm"
              name="files"
              multiple="false"
              @value-changed="handleFileUploader($event, 'ijazah_file')"
            >
            </DxFileUploader>
          </div>
        </DxPopup>

        <!-- <DxPopup
          :width="350"
          :height="inherit"
          :show-title="true"
          title="Update File"
          :drag-enabled="false"
          :hide-on-outside-click="true"
          v-model:visible="popupFileVisible"
        >
          <template #content>
            <DxForm>
              <DxItem :col-count="2" :col-span="2" item-type="group">
                <DxItem data-field="FirstName" />
                <DxItem data-field="LastName" />
                <DxItem data-field="Prefix" />
                <DxItem data-field="BirthDate" />
                <DxItem data-field="Position" />
                <DxItem data-field="HireDate" />
                <DxItem
                  :col-span="2"
                  :editor-options="{ height: 100 }"
                  data-field="Notes"
                  editor-type="dxTextArea"
                />
              </DxItem>

              <DxItem
                :col-count="2"
                :col-span="2"
                item-type="group"
                caption="Home Address"
              >
                <DxItem data-field="StateID" />
                <DxItem data-field="Address" />
              </DxItem>
            </DxForm>
          </template>
        </DxPopup> -->

        <div>
          <DxMenu
            :items="treeData"
            :show-first-submenu-mode="showFirstSubmenuModes"
            :orientation="orientation"
            :hide-submenu-on-mouse-leave="hideSubmenuOnMouseLeave"
            display-expr="text"
            @item-click="itemClick"
            selection-mode="single"
            :select-by-click="true"
          />

          <div class="title-container-pegawai">
            <div class="flag-pegawai" @click="popUpProfile($event)">
              <!-- <div class="flag-pegawai"> -->
              <img
                id="imageProfile"
                :src="imageUrl"
                alt="Example image"
                v-if="pegawaiResponse"
              />
              <DxTooltip
                :hide-on-outside-click="false"
                target="#imageProfile"
                show-event="mouseenter"
                hide-event="mouseleave"
              >
                Klik utk ubah foto pegawai
              </DxTooltip>
              <!-- <DxPopover
                :position="position"
                :target="'#imageProfile'"
                :width="260"
                show-event="mouseenter"
                hide-event="mouseleave"
                content-template="popoverContent"
              >
                Klik untuk ubah foto pegawai
              </DxPopover> -->
            </div>
            <div>
              <div class="country-name" v-if="pegawaiResponse">
                {{ pegawaiResponse.nama }}
              </div>

              <!-- <div v-if="jobHistoryResponse" class="job-history-title">
                {{ jobHistoryResponse[0].jabatan.nama }}
                <div
                  v-if="jobHistoryResponse[0].subBagian"
                  style="display: inline"
                >
                  - {{ jobHistoryResponse[0].subBagian.nama }}
                </div>
                <div
                  v-if="jobHistoryResponse[0].bagian"
                  style="display: inline"
                >
                  - {{ jobHistoryResponse[0].bagian.nama }}
                </div>
                - {{ jobHistoryResponse[0].cabang.nama }}
              </div> -->

              <div v-if="jobHistoryTitle" class="job-history-title">
                {{ jobHistoryTitle.jabatan.nama }}
                <div v-if="jobHistoryTitle.subBagian" style="display: inline">
                  - {{ jobHistoryTitle.subBagian.nama }}
                </div>
                <div v-if="jobHistoryTitle.bagian" style="display: inline">
                  - {{ jobHistoryTitle.bagian.nama }}
                </div>
                - {{ jobHistoryTitle.cabang.nama }}
              </div>
            </div>
          </div>
          <br />
          <!-- <div class="title-pegawai"></div> -->
          <DxTabPanel
            id="tabpanel"
            v-model:selected-index="tabPanelIndex"
            :data-source="tabSource"
            :animation-enabled="true"
            item-title-template="title"
            item-template="currentTemplate"
            @titleClick="tabTitleClick"
          >
            <template #title="{ data: item }">
              <span class="tab-panel-title">{{ item.text }}</span>
            </template>
            <template #tBasic>
              <div v-if="!editing && pegawaiResponse">
                <div class="table-container">
                  <table>
                    <tbody>
                      <tr>
                        <td>Nama</td>
                        <td class="padded-column">
                          {{ pegawaiResponse.nama }}
                        </td>
                        <td>Alamat</td>
                        <td>{{ pegawaiResponse.alamat }}</td>
                      </tr>
                      <tr>
                        <td>Tempat lahir</td>
                        <td class="padded-column">
                          {{ pegawaiResponse.tempat_lahir }}
                        </td>
                        <td>Tgl lahir</td>
                        <td>{{ formatTglLahir() }}</td>
                      </tr>
                      <tr>
                        <td>Telp</td>
                        <td class="padded-column">
                          {{ pegawaiResponse.telp }}
                        </td>
                        <td>Agama</td>
                        <td>
                          {{ pegawaiResponse.agama.nama }}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="4">
                          <dx-button
                            text="Edit"
                            @click="startEditing"
                            style="float: right"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-if="editing && pegawaiResponse" class="editors">
                <div class="editors-container">
                  <div class="left">
                    <DxTextBox
                      :styling-mode="stylingMode"
                      :label-mode="labelMode"
                      width="100%"
                      label="Nama"
                      placeholder="Nama"
                      v-model="pegawaiResponse.nama"
                    >
                      <DxValidator>
                        <DxRequiredRule />
                      </DxValidator>
                    </DxTextBox>

                    <DxTextBox
                      :styling-mode="stylingMode"
                      :label-mode="labelMode"
                      width="100%"
                      label="Tempat lahir"
                      placeholder="Tempat lahir"
                      v-model="pegawaiResponse.tempat_lahir"
                    >
                      <DxValidator>
                        <DxRequiredRule />
                      </DxValidator>
                    </DxTextBox>

                    <DxTextBox
                      :styling-mode="stylingMode"
                      :label-mode="labelMode"
                      width="100%"
                      label="Telp"
                      placeholder="Telp"
                      v-model="pegawaiResponse.telp"
                    >
                      <DxValidator>
                        <DxRequiredRule />
                      </DxValidator>
                    </DxTextBox>
                  </div>
                  <div class="right">
                    <DxTextBox
                      :styling-mode="stylingMode"
                      :label-mode="labelMode"
                      width="100%"
                      label="Alamat"
                      placeholder="Alamat"
                      v-model="pegawaiResponse.alamat"
                    >
                      <DxValidator>
                        <DxRequiredRule />
                      </DxValidator>
                    </DxTextBox>
                    <DxDateBox
                      :styling-mode="stylingMode"
                      :label-mode="labelMode"
                      :display-format="'dd/MM/yyyy'"
                      width="100%"
                      placeholder="Tgl lahir"
                      label="Tgl lahir"
                      v-model="pegawaiResponse.tgl_lahir"
                    >
                      <DxValidator>
                        <DxRequiredRule />
                      </DxValidator>
                    </DxDateBox>
                    <DxSelectBox
                      :dataSource="agamaSource"
                      valueExpr="id"
                      displayExpr="nama"
                      :searchEnabled="true"
                      searchExpr="nama"
                      search-mode="startswith"
                      :styling-mode="stylingMode"
                      :label-mode="labelMode"
                      width="100%"
                      placeholder="Agama"
                      label="Agama"
                      v-model="pegawaiResponse.agama_id"
                    >
                      <DxValidator>
                        <DxRequiredRule />
                      </DxValidator>
                    </DxSelectBox>
                  </div>
                </div>
                <div class="editors-container">
                  <!-- <div class="left"></div> -->
                  <div class="right">
                    <div class="button-container">
                      <DxButton
                        @click="validateClick('t1', $event)"
                        text="save"
                        type="default"
                        class="validate"
                        id="button-1"
                      />
                      <DxButton
                        @click="startEditing"
                        text="cancel"
                        class="validate"
                        id="button-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template #tKeluarga>
              <DxDataGrid
                id="dataGridKeluarga"
                :data-source="keluargaResponse"
                :focused-row-index="0"
                :show-borders="true"
                :show-column-lines="false"
                :focused-row-enabled="true"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                :allow-column-reordering="true"
                key-expr="id"
                @saved="saved($event, 'keluarga')"
                @editing-start="dataGridValidation('EditingStart')"
                @init-new-row="dataGridValidation('InitNewRow')"
                @row-inserting="dataGridValidation('RowInserting')"
                @row-inserted="dataGridValidation('RowInserted')"
                @row-updating="dataGridValidation('RowUpdating')"
                @row-updated="dataGridValidation('RowUpdated')"
                @row-deleted="dataGridValidation('RowDeleted')"
              >
                <dx-paging :page-size="10" />
                <dx-pager :show-page-size-selector="true" :show-info="true" />
                <dx-filter-row :visible="true" />

                <DxExport :enabled="true" :allow-export-selected-data="true" />
                <DxSelection mode="multiple" />
                <DxColumnFixing :enabled="true" />
                <DxToolbar>
                  <DxItem name="groupPanel" />
                  <DxItem location="after" template="button-template" />
                  <DxItem name="addRowButton" show-text="always" />
                  <DxItem name="exportButton" />
                  <DxItem name="columnChooserButton" />
                  <DxItem name="searchPanel" />
                </DxToolbar>
                <template #button-template>
                  <DxButton
                    text="Import data"
                    :width="136"
                    @click="importClick"
                  />
                </template>
                <DxEditing
                  :allow-updating="true"
                  :allow-adding="true"
                  :allow-deleting="true"
                  mode="row"
                  :new-row-position="bottom"
                />
                <DxSorting mode="multiple" />
                <dx-column data-field="nama" caption="Nama">
                  <DxRequiredRuleDataGrid
                /></dx-column>
                <!-- <dx-column data-field="id" caption="ID"> </dx-column> -->
                <dx-column
                  data-field="keluarga_hub_id"
                  caption="Hubungan Keluarga"
                  sort-order="asc"
                >
                  <DxLookupDataGrid
                    :data-source="keluargaHubSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <DxColumn data-field="tempat_lahir" caption="Tempat Lahir">
                  <DxRequiredRuleDataGrid
                /></DxColumn>
                <dx-column
                  data-field="tgl_lahir"
                  caption="Tgl lahir"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  editor-type="dxDateBox"
                >
                  <DxRequiredRuleDataGrid />
                </dx-column>

                <dx-column data-field="nik" caption="NIK" data-type="number">
                  <DxRequiredRuleDataGrid />
                  <DxPatternRule
                    :pattern="patternNumeric"
                    message="NIK adalah angka!"
                  />
                </dx-column>

                <dx-column
                  data-field="perkawinan_status_id"
                  caption="Status Pernikahan"
                >
                  <DxLookupDataGrid
                    :data-source="perkawinanStatusSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                  <DxRequiredRuleDataGrid />
                </dx-column>

                <dx-column data-field="jenis_kelamin" caption="Jenis kelamin">
                  <DxLookup :data-source="jenisKelaminSource" />
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <DxColumn data-field="" caption="Pekerjaan"></DxColumn>
                <dx-column data-field="agama_id" caption="Agama">
                  <DxLookupDataGrid
                    :data-source="agamaSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                  <DxRequiredRuleDataGrid />
                </dx-column>
              </DxDataGrid>
              <DxButton
                @click="dataGridSave($event, 'keluarga')"
                text="save"
                type="default"
                class="validate"
              />
            </template>
            <template #tPendidikan>
              <DxDataGrid
                id="dataGridPendidikan"
                :data-source="pendidikanResponse"
                :focused-row-index="0"
                :show-borders="true"
                :show-column-lines="false"
                :focused-row-enabled="true"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                :allow-column-reordering="true"
                key-expr="id"
                @saved="saved($event, 'pendidikan')"
                @cell-click="cellClicked($event)"
              >
                <dx-paging :page-size="10" />
                <dx-pager :show-page-size-selector="true" :show-info="true" />
                <dx-filter-row :visible="true" />

                <DxExport :enabled="true" :allow-export-selected-data="true" />
                <DxSelection mode="multiple" />
                <DxColumnFixing :enabled="true" />
                <DxToolbar>
                  <DxItem name="groupPanel" />
                  <DxItem location="after" template="button-template" />
                  <DxItem name="addRowButton" show-text="always" />
                  <DxItem name="exportButton" />
                  <DxItem name="columnChooserButton" />
                  <DxItem name="searchPanel" />
                </DxToolbar>
                <template #button-template>
                  <DxButton
                    text="Import data"
                    :width="136"
                    @click="importClick"
                  />
                </template>
                <DxEditing
                  :allow-updating="true"
                  :allow-adding="true"
                  :allow-deleting="true"
                  mode="row"
                  :new-row-position="bottom"
                />

                <dx-column
                  data-field="pendidikan_jenjang_id"
                  caption="Jenjang"
                  sort-order="asc"
                >
                  <DxLookupDataGrid
                    display-expr="nama"
                    value-expr="id"
                    :data-source="pendidikanJenjangSource"
                  />
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column data-field="institusi" caption="Nama institusi">
                  <DxRequiredRuleDataGrid
                /></dx-column>
                <dx-column data-field="fakultas" caption="Fakultas">
                  <DxRequiredRuleDataGrid
                /></dx-column>
                <dx-column data-field="jurusan" caption="Jurusan">
                  <DxRequiredRuleDataGrid
                /></dx-column>
                <dx-column data-field="ipk" caption="IPK" data-type="number">
                  <DxRequiredRuleDataGrid />
                  <DxPatternRule
                    :pattern="patternNumeric"
                    message="IPK adalah angka!"
                  />
                </dx-column>
                <dx-column data-field="tahun_mulai" caption="Tahun Mulai">
                  <DxRequiredRuleDataGrid />
                  <DxPatternRule
                    :pattern="patternTahun"
                    message="Tahun salah"
                  />
                </dx-column>
                <dx-column data-field="tahun_lulus" caption="Tahun Lulus">
                  <DxRequiredRuleDataGrid />
                  <DxRequiredRuleDataGrid />
                  <DxPatternRule
                    :pattern="patternTahun"
                    message="Tahun salah"
                  />
                </dx-column>
                <dx-column data-field="ijazah_no" caption="Nomor Ijazah">
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column
                  data-field="ijazah_tgl"
                  caption="Tgl Ijazah"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  editor-type="dxDateBox"
                >
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column data-field="ijazah_file" caption="File"></dx-column>
                <dx-column
                  cell-template="fileTemplate"
                  caption="File Ijazah"
                  data-field="ijazah_file"
                ></dx-column>
                <!-- #title="{ data: item } -->
                <!-- <template #fileTemplate="{ data }"> -->
                <template #fileTemplate>
                  <div class="small-button-container">
                    <DxButton
                      @click="handleClickPopUpFile"
                      icon="file"
                      text="file"
                    />
                  </div>
                </template>
              </DxDataGrid>
              <DxButton
                @click="dataGridSave($event, 'pendidikan')"
                text="save"
                type="default"
                class="validate"
              />
            </template>
            <template #tJobCurr>ini curr job</template>
            <template #tJobHistory>
              <DxDataGrid
                id="dataGridJobHistory"
                :data-source="jobHistoryResponse"
                :focused-row-index="0"
                :show-borders="true"
                :show-column-lines="false"
                :focused-row-enabled="true"
                :column-auto-width="true"
                :column-hiding-enabled="false"
                :allow-column-reordering="true"
                key-expr="id"
                @saved="saved($event, 'jobHistory')"
              >
                <dx-paging :page-size="10" />
                <dx-pager :show-page-size-selector="true" :show-info="true" />
                <dx-filter-row :visible="true" />

                <DxExport :enabled="true" :allow-export-selected-data="true" />
                <DxSelection mode="multiple" />
                <DxColumnFixing :enabled="true" />
                <DxToolbar>
                  <DxItem name="groupPanel" />
                  <DxItem location="after" template="button-template" />
                  <DxItem name="addRowButton" show-text="always" />
                  <DxItem name="exportButton" />
                  <DxItem name="columnChooserButton" />
                  <DxItem name="searchPanel" />
                </DxToolbar>
                <template #button-template>
                  <DxButton
                    text="Import data"
                    :width="136"
                    @click="importClick"
                  />
                </template>
                <DxEditing
                  :allow-updating="true"
                  :allow-adding="true"
                  :allow-deleting="true"
                  mode="row"
                  :new-row-position="bottom"
                />

                <dx-column data-field="jabatan_id" caption="Jabatan">
                  <DxLookupDataGrid
                    display-expr="nama"
                    value-expr="id"
                    :data-source="jabatanSource"
                  />
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column data-field="cabang_id" caption="Cabang">
                  <DxLookupDataGrid
                    display-expr="nama"
                    value-expr="id"
                    :data-source="cabangSource"
                  />
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column data-field="bagian_id" caption="Bagian">
                  <DxLookupDataGrid
                    display-expr="nama"
                    value-expr="id"
                    :data-source="bagianSource"
                  />
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column data-field="sub_bagian_id" caption="Sub Bagian">
                  <DxLookupDataGrid
                    display-expr="nama"
                    value-expr="id"
                    :data-source="subBagianSource"
                  />
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column data-field="golongan_id" caption="Golongan">
                  <DxLookupDataGrid
                    display-expr="nama"
                    value-expr="id"
                    :data-source="golonganSource"
                  />
                  <DxRequiredRuleDataGrid />
                </dx-column>

                <dx-column
                  data-field="tgl_mulai"
                  caption="Tgl Mulai"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  editor-type="dxDateBox"
                >
                  <DxRequiredRuleDataGrid />
                </dx-column>
                <dx-column
                  data-field="tgl_akhir"
                  caption="Tgl Akhir"
                  data-type="date"
                  :display-format="'dd/MM/yyyy'"
                  editor-type="dxDateBox"
                >
                </dx-column>
                <dx-column data-field="status" caption="Status">
                  <DxLookupDataGrid
                    display-expr="nama"
                    value-expr="val"
                    :data-source="statusSource"
                  />
                </dx-column>
              </DxDataGrid>
              <DxButton
                @click="dataGridSave($event, 'jobHistory')"
                text="save"
                type="default"
                class="validate"
              />
            </template>
          </DxTabPanel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DxMenu from "devextreme-vue/menu";
import DxTabPanel from "devextreme-vue/tab-panel";
import ODataStore from "devextreme/data/odata/store";
import router from "@/router";
import DxSelectBox from "devextreme-vue/select-box";
import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";
import DxButton from "devextreme-vue/button";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";
import notify from "devextreme/ui/notify";
import { DateTime } from "luxon";
import _ from "lodash";
import axios from "axios";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import { DxFileUploader } from "devextreme-vue/file-uploader";
// import DxPopover from "devextreme-vue/popover";
import { DxTooltip } from "devextreme-vue/tooltip";
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxPager,
  DxPaging,
  DxEditing,
  DxColumnFixing,
  DxSelection,
  DxExport,
  // DxButton,
  DxToolbar,
  DxLookup as DxLookupDataGrid,
  DxItem,
  DxPatternRule,
  DxSorting,
  DxRequiredRule as DxRequiredRuleDataGrid,
} from "devextreme-vue/data-grid";
const pegawaiSource = new ODataStore({
  type: "odata",
  url: "http://127.0.0.1/odata/Pegawais",
  key: "id",
  version: 4,
  beforeSend: function (e) {
    e.headers = {
      "odata-version": "4.0",
    };
    if (e.method === "PUT") e.method = "PATCH";
  },
});

function getPegawaiId() {
  return router.currentRoute.value.query.id;
}
function formatDateDisplay(dateOri) {
  const date = DateTime.fromJSDate(new Date(dateOri));
  return date.toFormat("dd/MM/yyyy");
}
function formatDateISO(dateOri) {
  const date = DateTime.fromJSDate(new Date(dateOri));
  return date.toFormat("yyyy-MM-dd");
}

async function fetchDataPegawai() {
  const odataStore = new ODataStore({
    type: "odata",
    url:
      "http://127.0.0.1/odata/Pegawais?$filter=id eq " +
      getPegawaiId() +
      "&$expand=agama",
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
    },
  });
  const data = await odataStore.load({});

  return data[0];
}

async function fetchDataPegawaiJob() {
  const odataStore = new ODataStore({
    type: "odata",
    url:
      "http://127.0.0.1/odata/JobHistories?$orderby=tgl_mulai desc&$expand=bagian,cabang,golongan,subBagian,jabatan&$filter=pegawai_id eq " +
      getPegawaiId(),
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
    },
  });
  const data = await odataStore.load({});
  return data;
}

async function fetchDataPegawaiKeluarga() {
  const odataStore = new ODataStore({
    type: "odata",
    url:
      "http://127.0.0.1/odata/Keluargas?$orderby=keluarga_hub_id asc&$filter=pegawai_id eq " +
      getPegawaiId(),
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
    },
  });
  const data = await odataStore.load({
    // filter: ['pegawai_id', '=', 1],
    // expand: ['bagian','cabang','golongan','sub_bagian','jabatan'],
    //menyebalkan
  });
  return data;
}

async function fetchDataPegawaiPendidikan() {
  const odataStore = new ODataStore({
    type: "odata",
    url:
      "http://127.0.0.1/odata/PendidikanHistories?$filter=pegawai_id eq " +
      getPegawaiId(),
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
    },
  });
  const data = await odataStore.load({});
  return data;
}
const tabMenus = [
  {
    items: [
      { text: "Basic info", template: "tBasic" },
      { text: "data keluarga", template: "tKeluarga" },
      { text: "riwayat pendidikan", template: "tPendidikan" },
    ],
  },
  {
    items: [
      { text: "Current job", template: "tJobCurr" },
      { text: "Riwayat pekerjaan", template: "tJobHistory" },
    ],
  },
];

export default {
  components: {
    DxMenu,
    DxTabPanel,
    DxSelectBox,
    DxTextBox,
    DxDateBox,
    DxButton,
    DxValidator,
    DxRequiredRule,
    DxDataGrid,
    DxFilterRow,
    DxPager,
    DxPaging,
    DxColumnFixing,
    DxColumn,
    DxSelection,
    DxExport,
    DxToolbar,
    DxLookupDataGrid,
    DxItem,
    DxEditing,
    DxRequiredRuleDataGrid,
    DxPatternRule,
    DxSorting,
    DxTooltip,
    DxPopup,
    DxFileUploader,

    DxToolbarItem,
    // DxPopover,
  },
  setup() {
    // const picture = "images/employees/06.png";
    // const imageUrl = `https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/${picture}`;
  },
  data() {
    const showSubmenuModes = [
      {
        name: "onHover",
        delay: { show: 0, hide: 500 },
      },
      {
        name: "onClick",
        delay: { show: 0, hide: 300 },
      },
    ];

    return {
      dataGridPopupCurrDataIdPendidikan: null,
      moreInfoButtonOptions: {
        text: "More info",
        onClick: () => {
          const message = "test";
          // const message = `More info about ${this.currentEmployee.FirstName} ${this.currentEmployee.LastName}`;
          notify(
            {
              message,
              position: {
                my: "center top",
                at: "center top",
              },
            },
            "success",
            3000
          );
        },
      },
      emailButtonOptions: {
        icon: "email",
        text: "Send",
        onClick: () => {
          const message = "test email";
          // const message = `Email is sent to ${this.currentEmployee.FirstName} ${this.currentEmployee.LastName}`;
          notify(
            {
              message,
              position: {
                my: "center top",
                at: "center top",
              },
            },
            "success",
            3000
          );
        },
      },
      closeButtonOptions: {
        text: "Close",
        onClick: () => {
          //tambahkan ijazahfile ke array
          this.ijazahFilePrep();
          this.popupFileVisible = false;
        },
      },
      closeButtonOptionsFoto: {
        text: "Close",
        onClick: () => {
          this.updateFotoPegawai();
        },
      },

      popupVisible: false,
      popupFileVisible: false,
      serverUrl: "http://127.0.0.1/",
      imageUrl: null,
      // "http://127.0.0.1/profiles/GBNDPZZIyfQNIbnM0UKInlyaTH527AYmANZKsabf.png",

      dataGridValid: true,
      patternTahun: /^\d{4}$/i,
      patternNumeric: /^\d+(?:[.,]\d+)?$/,

      pegawaiSource,
      jobHistoryResponse: null,
      pegawaiResponse: null,
      keluargaResponse: null,
      pendidikanResponse: null,
      keluargaHubSource: new ODataStore({
        url: "http://127.0.0.1/odata/KeluargaHubs",
        key: "id",
      }),
      perkawinanStatusSource: new ODataStore({
        url: "http://127.0.0.1/odata/PerkawinanStatuses",
        key: "id",
      }),
      agamaSource: new ODataStore({
        url: "http://127.0.0.1/odata/Agamas",
        key: "id",
      }),
      pendidikanJenjangSource: new ODataStore({
        url: "http://127.0.0.1/odata/PendidikanJenjangs",
        key: "id",
      }),
      jenisKelaminSource: ["L", "P"],
      jabatanSource: new ODataStore({
        url: "http://127.0.0.1/odata/Jabatans",
        key: "id",
      }),
      golonganSource: new ODataStore({
        url: "http://127.0.0.1/odata/Golongans",
        key: "id",
      }),
      bagianSource: new ODataStore({
        url: "http://127.0.0.1/odata/Bagians",
        key: "id",
      }),
      subBagianSource: new ODataStore({
        url: "http://127.0.0.1/odata/SubBagians",
        key: "id",
      }),
      cabangSource: new ODataStore({
        url: "http://127.0.0.1/odata/Cabangs",
        key: "id",
      }),
      statusSource: [
        { val: true, nama: "Aktif" },
        { val: false, nama: "Non Aktif" },
      ],

      tabPanelIndex: 0,
      tabMenus: tabMenus,
      tabSource: tabMenus[0].items,

      currentTemplate: "tBasic",
      treeData: [
        {
          id: 1,
          text: "Data Personal",
          templateIndex: 0,
          selected: true,
        },
        {
          id: 2,
          text: "Data Pekerjaan",
          templateIndex: 1,
          selected: false,
        },
      ],

      showSubmenuModes,
      showFirstSubmenuModes: showSubmenuModes[1],
      orientation: "horizontal",
      hideSubmenuOnMouseLeave: false,
      stylingMode: "underlined",
      //outlined, filled, underlined
      labelMode: "floating",
      editing: false,
      keluargaAxios: {
        insert: [],
        update: [],
        remove: [],
      },
      pendidikanAxios: {
        insert: [],
        update: [],
        remove: [],
      },
      jobHistoryAxios: {
        insert: [],
        update: [],
        remove: [],
      },
      jobHistoryTitle: null,
      animationConfig: {
        show: {
          type: "pop",
          from: {
            scale: 0,
          },
          to: {
            scale: 1,
          },
        },
        hide: {
          type: "fade",
          from: 1,
          to: 0,
        },
      },
      fotoPegawai: null,
      fileIjazahTemp: null,
      fileIjazahTempRowId: null,
      ijazahFileAxios: [],
    };
  },
  async mounted() {
    this.pegawaiResponse = await fetchDataPegawai();
    this.keluargaResponse = await fetchDataPegawaiKeluarga();
    this.jobHistoryResponse = await fetchDataPegawaiJob();
    this.pendidikanResponse = await fetchDataPegawaiPendidikan();
    // this.jobHistoryTitle = this.jobHistoryResponse[0];
    this.jobHistoryTitle = _.find(this.jobHistoryResponse, { status: true });
    this.imageUrl = this.serverUrl + this.pegawaiResponse.pegawai_foto_path;
  },
  methods: {
    downloadPdf() {
      var temp = _.find(this.pendidikanResponse, {
        id: this.dataGridPopupCurrDataIdPendidikan,
      });
      if (temp.ijazah_file_path) {
        console.log("ADA FILE DOWNLOAD");
        window.open(
          this.serverUrl + temp.ijazah_file_path,
          "_self",
          "location=yes"
        );
      } else {
        console.log("TIDAK ADA");
        notify("Tidak ada file ijazah", "error");
      }
    },
    cellClicked(e) {
      console.log(e);
      if (e.column.dataField == "ijazah_file") {
        this.dataGridPopupCurrDataIdPendidikan = e.key; //pendidikanFile yg sedang di edit
      }
    },
    handleClickPopUpFile() {
      this.popupFileVisible = true;
    },
    handleFileUploader(e, column) {
      console.log("=============HANDLEFILEUPLOADER===================");
      console.log(e);
      if (column == "pegawai_foto") this.fotoPegawai = e.value[0];
      if (column == "ijazah_file") {
        this.fileIjazahTemp = e.value[0];
        this.fileIjazahTempRowId = this.dataGridPopupCurrDataIdPendidikan;

        console.log(this.fileIjazahTemp);
        console.log(this.fileIjazahTempRowId);
      }
    },

    updateFotoPegawai() {
      console.log(this.fotoPegawai);
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      const formData = new FormData();
      formData.append("pegawai_id", getPegawaiId());
      formData.append(
        "pegawai_foto_path_old",
        this.pegawaiResponse.pegawai_foto_path
      );
      formData.append("pegawai_foto", this.fotoPegawai); //foto yg baru
      formData.append("pegawai_foto_old", this.pegawaiResponse.pegawai_foto);
      axios
        .post("http://127.0.0.1/api/update_foto_pegawai", formData, config)
        .then((response) => {
          console.log(response);
          this.pegawaiResponse.pegawai_foto_path =
            response.data.pegawai_foto_path;

          this.imageUrl =
            this.serverUrl + this.pegawaiResponse.pegawai_foto_path;
          this.$refs.fileUploaderFoto.instance.reset();
          notify("Axios post success.", "success");
          this.popupVisible = false;
          // reactivity system will update HTML automatically
        })
        .catch((error) => {
          notify("Axios post error.", "error");
          console.log(error);
        });

      // .then(function (res) {
      //   console.log(res);
      //   notify("Axios post success.", "success");
      // })
      // .catch(function (err) {
      //   console.log(err);
      //   notify("Axios post error.", "error");
      // });
    },
    popUpProfile(e) {
      console.log(e);
      this.popupVisible = true;
    },
    dataGridValidation(e) {
      console.log(e);
    },

    convertPrepVariableToAxios(prepVar, proxyVar) {
      var axiosVar = { insert: [], update: [], remove: [] };
      const myProxy = new Proxy(proxyVar, {});
      var myProxyChild = null;
      prepVar.insert.forEach((item) => {
        myProxyChild = _.find(myProxy, { id: item });
        axiosVar.insert.push(myProxyChild);
      });
      prepVar.update.forEach((item) => {
        myProxyChild = _.find(myProxy, { id: item });
        axiosVar.update.push(myProxyChild);
      });
      prepVar.remove.forEach((item) => {
        axiosVar.remove.push(item); //data terhapus dari keluargaresponse proxy, simpan data aja
      });
      return axiosVar;
    },
    convertPrepVariableIjazahToAxios(prepVar, proxyVar) {
      var axiosVar = [];
      const myProxy = new Proxy(proxyVar, {});
      var myProxyChild = null;
      prepVar.forEach((item) => {
        myProxyChild = _.find(myProxy, { id: item });
        axiosVar.insert.push(myProxyChild);
      });

      return axiosVar;
    },
    dataGridSave(e, table) {
      console.log("DATAGRIDSAVE");
      console.log(table);
      var axiosData;
      var axiosFile; //jika ada file image/pdf teruploaded

      if (table == "keluarga") {
        axiosData = this.convertPrepVariableToAxios(
          this.keluargaAxios,
          this.keluargaResponse
        );
      } else if (table == "pendidikan") {
        axiosData = this.convertPrepVariableToAxios(
          this.pendidikanAxios,
          this.pendidikanResponse
        );
        axiosFile = this.ijazahFileAxios;
      } else if (table == "jobHistory") {
        axiosData = this.convertPrepVariableToAxios(
          this.jobHistoryAxios,
          this.jobHistoryResponse
        );
      }

      console.log(axiosData);
      console.log("===================================");
      console.log(axiosFile);

      //  RIBET PAKE FORMDATA UNTUK OBJECT, PISAHKAN SAJA AXIOSNYA
      // formData.append("pegawai_id", getPegawaiId());
      // formData.append("insert", axiosData.insert);
      // formData.append("update", axiosData.update);
      // formData.append("remove", axiosData.remove);
      // formData.append("pdf", axiosFile);
      // console.log(formData);
      console.log("length " + axiosFile.length);

      const config = {
        headers: {
          "content-type": "application/json",
          // "content-type": "multipart/form-data",
        },
      };
      axios
        .post(
          "http://127.0.0.1/api/" + table,
          {
            insert: axiosData.insert,
            update: axiosData.update,
            remove: axiosData.remove,
            pegawai_id: getPegawaiId(),
          },
          config
        )
        .then((res) => {
          console.log(this.pegawaiResponse);
          console.log(res);
          notify("Axios post success.", "success");

          if (axiosFile.length > 0) {
            //formdata ids untuk row baru inserted, match idfiles dengan id hasil axios
            const formData = new FormData();

            axiosFile.forEach((value, index) => {
              formData.append("images[" + index + "]", value.file);
              if (_.includes(value.id, "-", true) === false) {
                //sudah ada idpendidikan
                formData.append("ids[" + index + "]", value.id);
                //pendidikan sudah ada, kemungkinan sudah punya ijazah lama tapi mau diganti dengan nilai axiosFile
                //simpan fileoldpath utk dihapus dari filesistem,
                //nilai fileoldpath ambil dari pendidikanresponse yang awal
                formData.append(
                  "file_old_paths[" + index + "]",
                  value.file_old_path
                );
              } else {
                //adalah databaru, blm ada idpendidikan
                var row = _.find(res.data.insertId, { id_datagrid: value.id });
                console.log(row);

                formData.append("ids[" + index + "]", row.id);
                //pendidikan baru, artinya sebelumnya tidak ada ijazah file. tdk perlu delete ijazah file
                formData.append("file_old_paths[" + index + "]", "");
              }
            });

            // update files dari datagrid!
            axios
              .post(
                "http://127.0.0.1/api/" + table + "_upload_files",
                formData,
                {
                  headers: {
                    "content-type": "multipart/form-data",
                  },
                }
              )
              .then((res) => {
                console.log(res);

                notify("Axios post success.", "success");
                var newPath = res.data.file_new_path;
                console.log("PENDIDIKANRESPONSE ASLI");
                console.log(this.pendidikanResponse);
                newPath.forEach((item) => {
                  console.log(item);
                  // _.set(
                  //   _.find(this.pendidikanResponse, { id: item.id }),
                  //   "ijazah_file_path",
                  //   item.ijazah_file_path
                  // );

                  var temp = _.find(this.pendidikanResponse, {
                    id: _.toNumber(item.id), //harus convert ke int, karena string ga diterima
                  });

                  _.set(
                    _.find(this.pendidikanResponse, {
                      id: _.toNumber(item.id),
                    }),
                    "ijazah_file_path",
                    item.ijazah_file_path
                  );

                  console.log(temp);
                });
                console.log("PENDIDIKANRESPONSE EDIT");
                console.log(this.pendidikanResponse);
              })

              // .then(
              //   function (res) {
              //     console.log(res);
              //     notify("Axios post success.", "success");
              //     //refresh link file ijazah
              //     console.log(this.pendidikanResponse);
              //     var newPath = res.data.file_new_path;
              //     newPath.forEach((item) => {
              //       console.log(item);
              //       // _.set(
              //       //   _.find(this.pendidikanResponse, { id: item.id }),
              //       //   "ijazah_file_path",
              //       //   item.ijazah_file_path
              //       // );
              //     });
              //   }.bind(this)
              // )
              .catch((err) => {
                console.log(err);
                notify("Axios post error.", "error");
              });
          }
        })
        .catch((err) => {
          console.log(err);
          notify("Axios post error.", "error");
        });
    },

    ijazahFilePrep() {
      console.log("===========IJAZAH FILE PREP=============");
      var tempIndex = _.findIndex(this.ijazahFileAxios, {
        id: this.fileIjazahTempRowId,
      });
      //jika ada rowid yang sudah ada di array, jangan push melainkan replace
      if (tempIndex >= 0) {
        //ada rowid yg udah dimasukkan ke ijazahfileaxios
        this.ijazahFileAxios[tempIndex].file = this.fileIjazahTemp;
      } else {
        //masukkan file ijazah update ke array

        var temp = _.find(this.pendidikanResponse, {
          id: this.fileIjazahTempRowId,
        });
        var oldPath = "";
        if (temp.ijazah_file_path) {
          oldPath = temp.ijazah_file_path;
        }

        this.ijazahFileAxios.push({
          file: this.fileIjazahTemp,
          id: this.fileIjazahTempRowId,
          file_old_path: oldPath,
        });
        console.log(this.ijazahFileAxios);
      }
    },

    keluargaPrep(changes) {
      switch (changes.type) {
        case "insert":
          this.keluargaAxios.insert.push(changes.key);
          break;
        case "update":
          if (_.includes(changes.key, "-", true) === false) {
            this.keluargaAxios.update.push(changes.key);
          }
          break;
        case "remove":
          if (_.includes(changes.key, "-", true) === false) {
            this.keluargaAxios.remove.push(changes.key);
          }
          break;
      }
    },
    jobHistoryPrep(changes) {
      switch (changes.type) {
        case "insert":
          this.jobHistoryAxios.insert.push(changes.key);
          break;
        case "update":
          if (_.includes(changes.key, "-", true) === false) {
            this.jobHistoryAxios.update.push(changes.key);
          }
          break;
        case "remove":
          if (_.includes(changes.key, "-", true) === false) {
            this.jobHistoryAxios.remove.push(changes.key);
          }
          break;
      }
    },
    pendidikanPrep(changes) {
      switch (changes.type) {
        case "insert":
          this.pendidikanAxios.insert.push(changes.key);
          break;
        case "update":
          if (_.includes(changes.key, "-", true) === false) {
            this.pendidikanAxios.update.push(changes.key);
          }
          break;
        case "remove":
          if (_.includes(changes.key, "-", true) === false) {
            this.pendidikanAxios.remove.push(changes.key);
          }
          break;
      }
    },
    saved(e, table) {
      console.log("SAVED");
      console.log(table);
      console.log(e);
      if (e.changes.length == 0) {
        console.log("null");
        return;
      }
      if (table == "keluarga") {
        this.keluargaPrep(e.changes[0]);
        console.log(this.keluargaAxios);
        console.log(this.keluargaResponse);
      } else if (table == "pendidikan") {
        this.pendidikanPrep(e.changes[0]);
        console.log(this.pendidikanAxios);
        console.log(this.pendidikanResponse);
      } else if (table == "jobHistory") {
        console.log(e.changes[0].data.tgl_akhir);
        if (e.changes[0].data.tgl_akhir == undefined) {
          console.log("tidak ada tgl akhir");
          var temp = _.find(this.jobHistoryResponse, { id: e.changes[0].key });
          var tempIndex = _.findIndex(this.jobHistoryResponse, {
            id: e.changes[0].key,
          });
          console.log(tempIndex);
          _.set(this.jobHistoryResponse, [tempIndex, "tgl_akhir"], null);
          console.log("HASIL");
          console.log(this.jobHistoryResponse);

          console.log(temp);
        } else {
          console.log("ada tgl akhir");
        }
        // if (!e.changes[0].data.tgl_akhir) {
        //   console.log("tidak ada tgl akhir");
        // } else {
        //   console.log("ada tgl akhir");
        // }

        this.jobHistoryPrep(e.changes[0]);
        console.log(this.jobHistoryAxios);
        console.log(this.jobHistoryResponse);
      }

      console.log("================================");
      // switch (e.changes[0].type) {
      //   case "insert":
      //     this.keluargaAxios.insert.push(e.changes[0].key);
      //     console.log("insert");
      //     break;
      //   case "update":
      //     this.keluargaAxios.update.push(e.changes[0].key);
      //     console.log("insert");
      //     break;
      //   case "remove":
      //     this.keluargaAxios.remove.push(e.changes[0].key);
      //     console.log("insert");
      //     break;
      // }
    },
    startEditing() {
      if (this.editing) this.editing = false;
      else this.editing = true;
    },
    formatTglLahir() {
      return formatDateDisplay(this.pegawaiResponse.tgl_lahir);
    },
    itemClick(e) {
      this.tabSource = this.tabMenus[e.itemData.templateIndex].items;
      this.treeData.forEach((item, index) => {
        //selected flag utk menu
        if (index == e.itemData.templateIndex) item.selected = true;
        else item.selected = false;
      });
    },
    validateClick(from, e) {
      console.log(from);

      const result = e.validationGroup.validate();
      if (result.isValid) {
        pegawaiSource
          .update(
            { id: this.pegawaiResponse.id },
            {
              nama: this.pegawaiResponse.nama,
              alamat: this.pegawaiResponse.alamat,
              tempat_lahir: this.pegawaiResponse.tempat_lahir,
              tgl_lahir: formatDateISO(this.pegawaiResponse.tgl_lahir),
              telp: this.pegawaiResponse.telp,
              agama_id: this.pegawaiResponse.agama_id,
            }
          )
          .then(
            (dataObj) => {
              console.log(dataObj);
              this.editing = false;
              this.agamaSource.byKey(this.pegawaiResponse.agama_id).then(
                (dataItem) => {
                  console.log(dataItem);
                  this.pegawaiResponse.agama.nama =
                    dataItem.nama; /* Process the "dataItem" here */
                },
                (error) => {
                  console.log(error); /* Handle the "error" here */
                }
              );
              notify("The task was saved successfully.", "success");
            },
            (error) => {
              console.log(error);
              notify("Saving error.", "error");
            }
          );
      } else {
        notify(
          "The task was not saved. Please check if all fields are valid.",
          "error"
        );
      }
    },
  },
};
</script>
<style scoped>
/* .small-button-container {
  display: inline-block;
  padding: 0;
  margin: 0;
}

.small-button-container .dx-button {
  padding: 0;
  font-size: 12px;
} */
.formA {
  margin-left: 3px;
}

.formA > div:first-child {
  margin-right: 320px;
}

.label {
  font-size: 18px;
  font-weight: 500;
}

#product-details {
  width: 400px;
  height: 400px;
  margin: 20px auto 0;
}

#product-details > img {
  height: 300px;
  width: 400px;
}

#product-details > .name {
  text-align: center;
  font-size: 20px;
}

#product-details > .price {
  text-align: center;
  font-size: 24px;
}

.dark #product-details > div {
  color: #f0f0f0;
}

.options {
  padding: 20px;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 260px;
  top: 0;
  background-color: rgba(191, 191, 191, 0.15);
}

.caption {
  font-size: 18px;
  font-weight: 500;
}

.option {
  margin-top: 10px;
}

.hidden {
  visibility: hidden;
}

.dx-menu-item-selected {
  background-color: rgba(0, 0, 0, 0.87) !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

.title-container-pegawai {
  /* min-height: 100px; */
  margin-bottom: 10px;
  padding-bottom: 2px;
  padding-top: 15px;
}

.title-pegawai2 {
  /* padding: 0 0 20px 0; */
  /* padding-top: 70px; */
  padding: 1px;

  display: block;
  /* background-color: rgba(191, 191, 191, 0.15);
  background-clip: content-box; */
}

.job-history-title {
  font-size: 15px;
}

.flag-pegawai2 {
  float: left;
  height: 100px;
  width: 106px;
  margin: 0 10px 10px 0;
  border: 1px solid #d2d3d5;
  border-radius: 50%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #fff;
  overflow: hidden;

  /* img {
    
  } */
}

img {
  height: 100px;
  display: block;
  margin: 0 auto;
}
</style>
